<script lang='ts'>
    import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "sveltestrap";
    import type { ThirdLicense } from "../Model/ThirdLicense";
    import ParamSelect from "./ParamSelect.svelte";
    import { thirdLicenseService } from "../services";
    import { createEventDispatcher } from "svelte";
    import { dateInputFormatter } from "../services/Functions";

    const dispatch = createEventDispatcher();

    export let license: ThirdLicense;
    export let removeButton: boolean;

    let open = false;
    let size = 'lg';

    const toggle = () => {
        size = 'lg';
        open = !open;
	};

    $: open = !!license;

    async function save() {
        let response = await thirdLicenseService.saveThirdLicense(license);

        if (response) {
            dispatch("addLicense", license);
            license = null;
            open = false;
        }
    }

    async function remove() {
        if (!confirm("¿Esta seguro de querer eliminar el parámetro?")) return;

        let response = await thirdLicenseService.removeThirdLicense(license.id, license.third_id);

        if (response) {
            dispatch("removeLicense", license);
            license = null;
            open = false;
        }
    }

    function changeDate(date) {
        license.exp_date = new Date(date).toISOString();
    }
</script>

<Modal isOpen={open} {toggle} {size}>
    <ModalHeader {toggle}>Editar permiso</ModalHeader>
    <ModalBody>
        {#if license}
            <ParamSelect bind:paramSelectId={license.license_type} paramType='licenseType' nothing/>

            <div class='mt-3'>
                <label for='exp_date' class='mb-2'>
                    Fecha de validez
                </label>
                <input 
                    class='form-control'
                    type='date' 
                    value={dateInputFormatter(license.exp_date)}
                    on:change={(e) => changeDate(e.srcElement.value)}
                />
            </div>
            
        {/if}
    </ModalBody>
    <ModalFooter>
        {#if removeButton}
            <Button color="danger" on:click={remove}>Eliminar</Button>
        {/if}
        <Button color="primary" on:click={save}>Guardar</Button>
    </ModalFooter>
</Modal>